import * as React from 'react';
const Arrow = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        {...props}
    >
        <path
            fill="#000"
            d="M7.82 2.94a1.33 1.33 0 0 0-1.882 1.88L11.107 10l-5.169 5.18a1.33 1.33 0 0 0 1.883 1.88l6.352-6.353a1 1 0 0 0 0-1.414L7.82 2.94Z"
        />
    </svg>
);
export default Arrow;
